import { useState, useEffect, useContext } from 'react';
import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import NurseMenuPopup from './nurseMenuPopup';
import NurseHeader from './nurseHeader';
import ConfirmDialog from '../shared/components/confirmDialog';
import { HomeContext } from '../utils/contexts/homeContext';
import { GetNurseSeachAPIUrl, NurseAPIUrl, GetNoToCurrencyFormat } from '../utils/extensions/functionEx';
import PageLoading from '../shared/components/backdrop';
import { useCookies } from 'react-cookie';

const NurseSearch = (props) => {

    const { ShowAPIError, OpenErrorAlert, OpenSuccessAlert, SetNurseSearchText, homeState, ClearLoggedUser } = useContext(HomeContext);

    const [dbNurses, setBbNurses] = useState([]);
    const [isOpenPageLoad, setIsOpenPageLoad] = useState(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [selectedNurseId, setSelectedNurseId] = useState(0);

    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    useEffect(() => {
        async function fetchNurses() {
            searchNurses(homeState.nurseSearchText.length > 0 ? homeState.nurseSearchText : '');
        }
        fetchNurses();
    }, []);

    const searchNurses = async (searchText) => {
        try {
            setIsOpenPageLoad(true);
            let tempNurses = [];
            SetNurseSearchText(searchText);

            const headers = new Headers();
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(GetNurseSeachAPIUrl(homeState.loggedUser.companyCode, searchText), { headers: headers });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                tempNurses = await response.json();
            } else {
                ShowAPIError(response)
            }
            setBbNurses([...tempNurses]);
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
        }
    }

    const handleNurseSearchClick = async (searchText) => {
        await searchNurses(searchText.trim());
    }

    const handlePageLoadingClose = () => {
        setIsOpenPageLoad(false);
    }

    const handleDeleteClick = (nurseId) => {
        setIsDeleteConfirmOpen(true);
        setSelectedNurseId(nurseId);
    }

    const handleDeleteCancelClick = () => {
        setIsDeleteConfirmOpen(false);
        setSelectedNurseId(0);
    }

    const handleDeleteOKClick = async () => {
        try {
            setIsOpenPageLoad(true);
            setIsDeleteConfirmOpen(false);

            const headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Accept-Encoding", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);
            const response = await fetch(NurseAPIUrl(homeState.loggedUser.companyCode), {
                method: "DELETE",
                headers: headers,
                body: JSON.stringify({ 'id': selectedNurseId })
            });
            if (response.status === 401) {
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            } else if (response.status === 200) {
                OpenSuccessAlert('Nurse details successfully deleted.');
                await searchNurses(homeState.nurseSearchText.length > 0 ? homeState.nurseSearchText : '');
            } else {
                ShowAPIError(response);
            }
        }
        catch (error) {
            OpenErrorAlert(error)
        } finally {
            setIsOpenPageLoad(false);
            setSelectedNurseId(0);
        }
    }

    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                {
                    isOpenPageLoad &&
                    <PageLoading isOpenPageLoading={isOpenPageLoad} handleClose={handlePageLoadingClose} />
                }
                {
                    isDeleteConfirmOpen &&
                    <ConfirmDialog isOpen={isDeleteConfirmOpen} title="Confirm Delete"
                        message="Are you sure you want to delete the nurse?"
                        handleClickOK={handleDeleteOKClick}
                        handleClickCancel={handleDeleteCancelClick} />

                }
                <NurseHeader handleNurseSearchClick={handleNurseSearchClick} />
                <TableContainer component={Paper} sx={{ maxHeight: '79vh', borderRadius: '0' }}>
                    <Table stickyHeader sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" sx={{ width: '55px' }}></StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Code</StyledTableCell>
                                <StyledTableCell>Name</StyledTableCell>
                                <StyledTableCell sx={{ width: '650px' }}>Phone Nos</StyledTableCell>
                                {/* <StyledTableCell sx={{ width: '200px' }}>WhatsApp No</StyledTableCell> */}
                                <StyledTableCell sx={{ width: '150px' }}>Advance Amount</StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Status</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dbNurses.map((row) => (
                                <StyledTableRow key={row.id.toString()}>
                                    <StyledTableCell align="center">
                                        <NurseMenuPopup nurseRow={row} handleDeleteClick={handleDeleteClick} />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {row.code}
                                    </StyledTableCell>
                                    <StyledTableCell>{row.nurse_name}</StyledTableCell>
                                    <StyledTableCell>{row.phone}</StyledTableCell>
                                    {/* <StyledTableCell>{row.whatsapp_no}</StyledTableCell> */}
                                    <StyledTableCell>{GetNoToCurrencyFormat(row.advance_amount)}</StyledTableCell>
                                    <StyledTableCell>{
                                        row.is_service_found ? "In Service" :
                                            (row.is_vacation_found ? "On Leave" : "Not in Service")
                                    }</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </Box>
    );
}
export default NurseSearch;